import React, { Component } from 'react';
import { Redirect } from 'react-router';
import styled, { keyframes } from 'styled-components';

import color from '../../utils/colors';

const animation = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0%);
    }
`;

export class ChangePageAnimation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRedirect: false,
        };

        this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
    }

    handleAnimationEnd() {
        const { handleChangePageAnimationEnd } = this.props;
        if (window.pageYOffset > 0) {
            window.scrollTo(0, 0);
        }
        this.setState({ isRedirect: true }, handleChangePageAnimationEnd);
    }

    render() {
        const { isRedirect } = this.state;
        const { to } = this.props;
        const { clientHeight, scrollTop } = document.documentElement;
        // чуть увеличиваем блок чтобы при ресайзе не было видно футера
        const height = clientHeight + 100;

        return (
            isRedirect ? (
                <Redirect to={to} />
            ) : (
                <Root
                    onAnimationEnd={this.handleAnimationEnd}
                    scrollTop={scrollTop}
                    clientHeight={clientHeight}
                    height={height}
                />
            )
        );
    }
}

export default ChangePageAnimation;

const Root = styled.div`
    position: absolute;
    left: 0;
    top: ${({ scrollTop }) => `${scrollTop}px`};
    width: 100%;
    height: ${({ height }) => (`${height}px`)};
    transform: ${({ scrollTop, clientHeight }) => `${clientHeight + scrollTop}px`};
    animation: .7s ease-in-out 0s ${animation};
    background-color: ${color.TEXT_SECONDARY};
`;
